// useTheme is imported from native base because when imported from ~hooks it create require cycle
import { Box, IBoxProps, useTheme } from 'native-base'

type BoxWithShadowProps = IBoxProps & { shadowSize: 's' | 'l' | 't' }

export const BoxWithShadow = ({ style, shadowSize = 'l', ...rest }: BoxWithShadowProps) => {
  const { shadows } = useTheme()
  return <Box bg="white" style={[shadows[shadowSize], style]} {...rest} />
}
